<template>
  <form 
    class="sm-schedule-pickup"
    @submit.prevent="handleSubmit"
  >
    <h4>{{title}}</h4>
    <slot name="content"></slot>
    <div class="sm-schedule-pickup__flex">
      <datepicker-wrap
        :label="'Date'"
        :notBefore="notBefore"
        :notAfter="notAfter"
        :inActiveDates="inActiveDates"
        :disabledWeekdays="disabledWeekdays"
        @input="val => selectedDate = val"
      />
      <dropdown-wrap
        :label="'Time'"
        :options="timeOptions"
        :val="selectedTime ? timeOptions.find(item => item.value == selectedTime) : timeOptions[0]"
        :placeholder="'Select time'"
        :class="{
          'no-val': !selectedTime,
          'disabled': !selectedDate
        }"
        @input="(e) => selectedTime = e.value"
      />
    </div>
    <btn-block
      :type="'submit'"
      :text="btnText"
      :class="{
        'disabled': !selectedDate || !selectedTime
      }"
    />
  </form>
</template>

<script>
import DatepickerWrap from '@/components/DatepickerWrap';
import DropdownWrap from '@/components/DropdownWrap';
import {PrepareTimeArray} from '@/utils/time';
import WeekDays from '@/settings/week-days';

export default {
  name: 'schedule-pickup',
  components: {
    'datepicker-wrap': DatepickerWrap,
    'dropdown-wrap': DropdownWrap
  },
  props: {
    pickUpSettings: {
      type: Array,
      default: () => []
    },
    btnText: {
      type: String,
      default: "Submit"
    },
    title: {
      type: String,
      default: "Select a mail pick up time and date"
    },
    inActiveDates: {
      type: Array,
      default: () => []
    },
    notBefore: {
      type: Date,
      default: () => new Date()
    },
    notAfter: {
      type: Date,
      default: () => null
    }
  },
  data() {
    return {
      selectedDate: '',
      selectedTime: ''
    }
  },
  computed: {
    timeOptions() {
      if (!this.selectedDate || !this.pickUpSettings.length)
        return [];
    
      // let weekDay = new Date(this.selectedDate).getDay();
      // let daySettings = this.pickUpSettings.find(day => day.day == WeekDays.find(item => item.id == weekDay).short);

      const dt = this.$moment(this.selectedDate, "YYYY-MM-DD")
      let weekDay = dt.format('ddd').toLowerCase();
      let daySettings = this.pickUpSettings.find(option => option.day == weekDay);

      if (!daySettings)
        return [];

      return PrepareTimeArray(daySettings.from, daySettings.to);
    },
    disabledWeekdays() {
      if (!this.pickUpSettings.length)
        return [];

      let enabledDays = this.pickUpSettings.filter(day => !day.enabled);

      if (!enabledDays.length)
        return [];

      return enabledDays.map(day => WeekDays.find(d => d.short == day.day).id);
    }
  },
  methods: {
    handleSubmit() {
      this.$emit('submit', `${this.selectedDate}T${this.selectedTime}:00.000Z`);
    }
  },
  watch: {
    selectedDate() {
      this.selectedTime = '';
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/common/mail/_schedule-pickup.scss';
</style>